export default "https://cdn-static.gokick.com/assets/545fd9dea55dc30417fabffa3a2a88024697daac/images/sleep-blueberry.4c08b7b0b460cc7a3bc9f6ddf7107552.png";